import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './agent-booking-visio-allocated.component.ajs.html';

const MODULE_NAME = 'agentBookingVisioAllocated';

class AgentBookingVisioAllocatedCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;

  $onInit() {}
}

export class AgentBookingVisioAllocated implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = [AgentBookingVisioAllocatedCtrl];
}

export default MODULE_NAME;
